
// @ts-nocheck


export const localeCodes =  [
  "en",
  "tr",
  "ar"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_cb4b506c",
      load: () => import("#nuxt-i18n/cb4b506c" /* webpackChunkName: "locale_en_46json_cb4b506c" */),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_46json_20a3a988",
      load: () => import("#nuxt-i18n/20a3a988" /* webpackChunkName: "locale_tr_46json_20a3a988" */),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_ar_46json_659619b4",
      load: () => import("#nuxt-i18n/659619b4" /* webpackChunkName: "locale_ar_46json_659619b4" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      name: "english",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "tr",
      language: "tr-TR",
      name: "turkish",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/tr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ar",
      language: "ar-AR",
      name: "arabic",
      dir: "rtl",
      files: [
        {
          path: "/opt/buildhome/repo/i18n/locales/ar.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://cobe1.com",
  customRoutes: "config",
  pages: {
    login: {
      tr: "/giris",
      en: "/login",
      ar: "/تسجيل-الدخول"
    },
    register: {
      tr: "/kayit",
      en: "/register",
      ar: "/تسجيل"
    },
    "forgot-password": {
      tr: "/sifremi-unuttum",
      en: "/forgot-password",
      ar: "/نسيت-كلمة-المرور"
    },
    "reset-password": {
      tr: "/sifre-sifirlama",
      en: "/reset-password",
      ar: "/إعادة-تعيين-كلمة-المرور"
    },
    "verify-email": {
      tr: "/email-dogrulama",
      en: "/verify-email",
      ar: "/تأكيد-البريد-الإلكتروني"
    },
    "update-verify-email": {
      tr: "/email-guncelleme-dogrulama",
      en: "/update-verify-email",
      ar: "/تحديث-تأكيد-البريد-الإلكتروني"
    },
    error: {
      tr: "/hata",
      en: "/error",
      ar: "/خطأ"
    },
    index: {
      tr: "/",
      en: "/",
      ar: "/"
    },
    chat: {
      tr: "/sohbet",
      en: "/chat",
      ar: "/الدردشة"
    },
    "chat-profession": {
      tr: "/sohbet/[profession]",
      en: "/chat/[profession]",
      ar: "/الدردشة/[profession]"
    },
    "chat-profession-conversationId": {
      tr: "/sohbet/[profession]/[conversationId]",
      en: "/chat/[profession]/[conversationId]",
      ar: "/الدردشة/[profession]/[conversationId]"
    },
    "chat-share-publicId": {
      tr: "/sohbet/paylas/[publicId]",
      en: "/chat/share/[publicId]",
      ar: "/الدردشة/مشاركة/[publicId]"
    },
    profession: {
      tr: "/[profession]",
      en: "/[profession]",
      ar: "/مهنة/[profession]"
    },
    "profession-country": {
      tr: "/[profession]/[country]",
      en: "/[profession]/[country]",
      ar: "/مهنة/[profession]/[country]"
    },
    terms: {
      tr: "/kullanim-sartlari",
      en: "/terms",
      ar: "/الشروط-و-الاحكام"
    },
    privacy: {
      tr: "/gizlilik-politikasi",
      en: "/privacy",
      ar: "/سياسة-الخصوصية"
    },
    cookies: {
      tr: "/cerezler",
      en: "/cookies",
      ar: "/ملفات-تعريف-الارتباط"
    },
    pricing: {
      tr: "/fiyatlandirma",
      en: "/pricing",
      ar: "/الأسعار"
    }
  },
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    name: "english",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    language: "tr-TR",
    name: "turkish",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/tr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    language: "ar-AR",
    name: "arabic",
    dir: "rtl",
    files: [
      {
        path: "/opt/buildhome/repo/i18n/locales/ar.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/